<template>
  <div class="app-substitute-sim-card-wrapper">
    <slot name="txtBefore"></slot>
    <SelectSimCardType v-if="showSelectSimCard" :nextStep="reviewSimCardStepName">
      <template v-for="slot in possibleChildSlotsFor('SelectSimCard')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SelectSimCardType>
    <ReviewSimCard v-if="showReviewSelectSimCard" :previousStep="selectSimCardStepName" :nextStep="successStepName">
      <template v-for="slot in possibleChildSlotsFor('ReviewSimCard')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ReviewSimCard>
    <Success v-if="showSuccess" @done="resetState()">
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import { mapGetters, mapMutations } from 'vuex'
import SelectSimCardType, { stepName as selectSimCardStepName } from '@/components/process/generic/SimCard/SubstituteSimCard/SelectSimCardType.vue'
import ReviewSimCard, { stepName as reviewSimCardStepName } from '@/components/process/generic/SimCard/SubstituteSimCard/ReviewSimCard.vue'
import Success, { stepName as successStepName } from '../../../../generic/Success.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'SubstituteSimCardWrapper',
  mixins: [
    transaction('substituteSimCard'),
    slotProxy()
  ],
  import: {
    reviewSimCardStepName,
    selectSimCardStepName,
    successStepName
  },
  components: { ReviewSimCard, SelectSimCardType, Success },
  computed: {
    ...mapGetters('substituteSimCard', [
      'currentStep'
    ]),
    showSelectSimCard () {
      return this.currentStep === selectSimCardStepName
    },
    showReviewSelectSimCard () {
      return this.currentStep === reviewSimCardStepName
    },
    showSuccess () {
      return this.currentStep === successStepName
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', {
      resetStore: 'reset'
    }),
    resetState () {
      this.resetTransaction()
      this.resetStore()
    }
  }
}
</script>
